const styles = theme => ({
  root: {
    marginTop: 18,
    marginLeft: 0,
    marginBottom: 18,
    textAlign: 'center',
    alignItems: 'center',
  },
  textColor: {
    color: 'rgba(52, 118, 203, 1.0)',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/MultifolderView/components/User/components/Description/styles.js